<template>
    <div class="status-save">
        <i v-if="showTickForSaveStatus" class="far fa-check text-success"></i>
        <i v-if="showCrossForSaveStatus" class="far fa-times text-danger"></i>
        <span class="hidden-xs d-none d-sm-inline">{{ textForSaveStatus }}</span>
    </div><!-- /.status-save -->
</template>

<script>
    import AppConstants from '@/support/app-constants'
    import { SET_SAVE_STATUS } from 'vx/mutations'
    import { mapState, mapActions, mapMutations } from 'vuex'

    export default {
        mounted: function() {
            this.handlers = {
                dirty: () => {
                    this[SET_SAVE_STATUS](AppConstants.save_status.UNSAVED)
                },
                saving: () => {
                    this[SET_SAVE_STATUS](AppConstants.save_status.SAVING)
                },
                saved: () => {
                    //Only apply is status is saving to stop race condtions when editing multiple fields
                    if (this.save_status == AppConstants.save_status.SAVING) {
                        this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
                    }
                },
                unsaved: () => {
                    this[SET_SAVE_STATUS](AppConstants.save_status.UNSAVED)
                },
                error: () => {
                    this[SET_SAVE_STATUS](AppConstants.save_status.ERROR_SAVING)
                }
            }

            Object.keys(this.handlers).forEach((event) => {
                this.$status.$on(event, this.handlers[event])
            })
        },

        beforeDestroy () {
            Object.keys(this.handlers).forEach((event) => {
                this.$status.$off(event, this.handlers[event])
            })
        },

        computed: {
            ...mapState('settings/app', ['save_status']),

            showTickForSaveStatus () {
                return this.save_status == AppConstants.save_status.SAVED
            },

            showCrossForSaveStatus () {
                return this.save_status == AppConstants.save_status.ERROR_SAVING
            },

            textForSaveStatus () {
                if (this.save_status == AppConstants.save_status.SAVED) {
                    return 'All Changes Saved'
                } else if (this.save_status == AppConstants.save_status.SAVING) {
                    return 'Saving...'
                } else if (this.save_status == AppConstants.save_status.UNSAVED) {
                    return 'Unsaved Changes'
                } else if (this.save_status == AppConstants.save_status.ERROR_SAVING) {
                    return 'Error Saving!'
                }

                return 'Unknown Save Status'
            }
        },
        methods: {
            ...mapMutations('settings/app', [SET_SAVE_STATUS])
        }
    }
</script>